import { combineReducers } from "redux";
import BackOrderedItemsReducer from "@galarson/Store/BackOrderedItems/BackOrderedItemsReducer";
import Top100ItemsReducer from "@galarson/Store/Top100Items/Top100ItemsReducer";
import ProductsReducer from "@galarson/Store/WareHouseData/ProductsReducer";
import AdditionalOrderInformationReducer from "@galarson/Store/AdditionalOrderInformation/AdditionalOrderInformationReducer";

const dataReducers = {
    BackOrderedItem: BackOrderedItemsReducer,
    Top100Item: Top100ItemsReducer,
    WareHuouseData: ProductsReducer,
    AdditionalOrderInformation: AdditionalOrderInformationReducer
};

export type DataReducers = typeof dataReducers;

const combinedDataReducer = combineReducers(dataReducers as any);

export default combinedDataReducer;